// extracted by mini-css-extract-plugin
export var addButton = "_jb-0";
export var border = "_jb-8";
export var check = "_jb-h";
export var danger = "_jb-6";
export var dropdownContainer = "_jb-1";
export var editModalBody = "_jb-j";
export var footerContainer = "_jb-i";
export var fullWidth = "_jb-a";
export var hide = "_jb-9";
export var icon = "_jb-3";
export var input = "_jb-7";
export var inputFlex = "_jb-b";
export var inputWrapper = "_jb-c";
export var manualFocus = "_jb-5";
export var optionButton = "_jb-4";
export var pillWrapper = "_jb-e";
export var pointer = "_jb-2";
export var showOverflow = "_jb-f";
export var tagsFlex = "_jb-d";
export var xButton = "_jb-g";